import { Backspace } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';
import { useCallback } from 'react';

type Props = {
  value: string;
  onChange: (newValue: string) => void;
  size?: 'small';
  hasDot?: boolean;
};

const KeyBoard = ({ value, onChange, hasDot, size }: Props) => {
  const handleNumClick = useCallback(
    (num: string) => {
      onChange(`${value}${num}`);
    },
    [onChange, value]
  );

  const handleClearPin = useCallback(() => {
    onChange('');
  }, [onChange]);

  const mb = size === 'small' ? 2 : 3;
  const width = 44;

  return (
    <Grid container sx={{ mx: 'auto', maxWidth: 300, pt: mb }}>
      {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((num) => (
        <Grid item xs={4} textAlign="center" key={num} sx={{ mb }}>
          <IconButton sx={{ width }} onClick={() => handleNumClick(num)}>
            {num}
          </IconButton>
        </Grid>
      ))}

      <Grid item xs={4} textAlign="center" sx={{ mb }}>
        {hasDot && (
          <IconButton sx={{ width }} onClick={() => handleNumClick('.')}>
            .
          </IconButton>
        )}
      </Grid>

      <Grid item xs={4} textAlign="center" sx={{ mb }}>
        <IconButton sx={{ width }} onClick={() => handleNumClick('0')}>
          0
        </IconButton>
      </Grid>

      <Grid item xs={4} textAlign="center" sx={{ mb }}>
        <IconButton sx={{ width }} onClick={handleClearPin}>
          <Backspace />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default KeyBoard;
